<template>
  <v-card :style="backOpacity">
    <v-card-title
      >コピーボタン・追加ボタンの設定 CopybuttonForm.vue</v-card-title
    >
    <v-card-text>
      <v-container>
        <p>
          ※「サブページの値コピー」をする場合は対象のサブページよりも下の行に配置してください。
        </p>
        <v-row>
          <v-col cols="4">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              :items="colors"
              v-model="returnData.color"
              label="ボタンの色"
              :rules="[varidation.required]"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="flag1"
              label="[追加]時のサブページでコピーする値を指定"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-model="hideButton"
              label="ボタン非表示"
              value="true"
              @change="inputColor"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="flag1"
          ><v-col cols="4">
            <search-Page
              label="サブページのPageID"
              v-model="subPageID"
              searchPage
            ></search-Page>
          </v-col>
          <v-col cols="4">
            <search-Page
              label="サブページのformID"
              v-model="subPageFormID"
              samePage
            ></search-Page>
          </v-col>
        </v-row>

        <v-row>
          <div v-for="(v, i) in values" :key="i" class="mb-4">
            <v-col cols="auto">
              <v-text-field
                class="d-inline"
                label="項目名"
                v-model="v.Label"
                disabled
                required
              ></v-text-field>
              <v-checkbox v-model="v.flag" label="コピー対象"></v-checkbox>
              <v-checkbox
                v-model="v.optionFlag"
                label="オプション"
                @change="deleteOption(v)"
              ></v-checkbox>
              <v-col cols="auto">
                <v-text-field
                  v-if="v.optionFlag"
                  label="オプション"
                  v-model="v.option"
                ></v-text-field>
                <p v-if="v.optionFlag">※ add → コピー時に+1加算される</p>
              </v-col>
            </v-col>
          </div>
        </v-row>
        <v-row>
          <v-btn class="ma-2" color="success" @click="CheckALL"
            >Check ALL</v-btn
          >
          <v-btn class="ma-2" color="success" @click="CheckoutALL"
            >Checkout ALL</v-btn
          >
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="success" @click="reset">リセット</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-show="showButton"
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import searchPage from "./common/searchPage.vue";
import { RepositoryFactory } from "../../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  components: {
    searchPage,
  },
  props: {
    label: String,
    //init: String,
    type: Number,
    position: Number,
    //個別値
    color: String,
    value: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        init: this.init,
        type: this.type,
        position: this.position,
        //未使用
        cols: 0,
        //
        color: this.color,
        value: "test",
      },
      backOpacity: "opacity: 1",
      showButton: false,
      rules: [],
      flag1: "",
      subPageID: 0,
      subPageFormID: 0,
      hideButton: "",

      colors: [
        "primary",
        "yellow",
        "red",
        "blue",
        "yellow lighten-4",
        "blue-grey darken-1",
      ],
      values: [],
      varidation: {
        required: (value) => !!value || "必須項目です",
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
      },
    };
  },
  async mounted() {
    setTimeout(() => {
      this.showButton = true;
    }, 500);

    await this.getInit();
  },
  methods: {
    async getInit() {
      //
      console.log(this.type);
      let tmp = this.color.split(",");
      if (!tmp[0]) {
        this.hideButton = "true";
      }
      if (tmp.length > 1 && Number(tmp[1]) != 0) {
        this.returnData.color = tmp[0];
        this.subPageID = tmp[1];
        this.flag1 = "true";
        //初期生成には無い場合がある
        if (tmp.length >= 3) {
          this.subPageFormID = tmp[2];
        }
      }
      //検索
      if (this.value == "") {
        let num;
        if (
          typeof this.subPageID == "undefined" ||
          Number(this.subPageID) == 0 ||
          Number(this.subPageID) == "NaN"
        ) {
          num = this.$route.params.page_id;
        } else {
          num = this.subPageID;
        }
        let data = {
          pageID: Number(num),
          area: [[]],
        };
        //新規作成時に既存フォームをすべて読み込む
        const response = await api.GetForm(data);
        let arr = [];
        response.data[0].forEach((d, i) => {
          const tmp = response.data.map((item) => {
            return {
              ID: item[i].ID,
              Label: item[i].Label,
              flag: true,
              optionFlag: false,
              option: "",
            };
          });
          arr = arr.concat(tmp);
        });
        this.values = arr.filter((a) => a.ID != 0);
      } else {
        console.log("既存フォームの修正");
        //既にvaluesが存在する場合
        this.values = JSON.parse(this.value);
      }
    },
    submit() {
      if (this.hideButton === "true") {
        this.returnData.color = "";
      }
      if (this.flag1 == "true" && this.subPageID != 0) {
        this.returnData.color +=
          "," + Number(this.subPageID) + "," + Number(this.subPageFormID);
      }
      //valuesからチェックが入っていない物を全て削除する
      let tmp = this.values.filter((v) => v.flag == true);
      this.returnData.value = JSON.stringify(tmp);
      this.$emit("clickSubmit", this.returnData);
    },
    reset() {
      this.returnData.value = "";
      if (this.flag1 == "true" && Number(this.subPageID) != 0) {
        this.returnData.color += "," + Number(this.subPageID);
      }
      this.$emit("clickSubmit", this.returnData);
    },
    CheckALL() {
      this.values.map((v) => {
        v.flag = true;
      });
    },
    CheckoutALL() {
      this.values.map((v) => {
        v.flag = false;
        v.optionFlag = false;
      });
    },
    deleteOption(v) {
      if (!v.optionFlag) {
        v.option = "";
      }
    },
    inputColor() {
      if (this.hideButton !== "true") {
        this.returnData.color = "red";
      }
    },
  },
};
</script>
